import React from "react";

const PlayButton = ({ fill, className }) => (
	<svg
		className={className}
		width="100%"
		height="100%"
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="30" cy="30" r="30" fill={fill} />
		<path d="M40.6155 29.7692L24.6924 41.9602L24.6924 17.5782L40.6155 29.7692Z" fill="white" />
	</svg>
);

export default PlayButton;
